import { makeStyles, Theme } from '@material-ui/core';
import { colors } from 'global/react-mui/theme/colors';

export const useStyles = makeStyles((theme: Theme) => ({
	root: {},
	modal: {
		width: '100vw',
		flexShrink: 0,
	},
	drawerPaper: {
		width: '100vw',
		position: 'absolute',
		[theme.breakpoints.up('lg')]: {
			width: '80vw',
			maxWidth: 1256,
		},
	},
	button: {
		maxWidth: 'min-content',
		margin: 0,
		'& span': {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			whiteSpace: 'nowrap',
			color: colors['dark-grey'],
			paddingLeft: 8,
			paddingRight: 8,
			'& div': {
				marginRight: '4px',
			},
		},
		[theme.breakpoints.up('md')]: {
			margin: '24px',
		},
	},
}));
